import GeoMoverDB from '@/db/indexeddb'

export default {
  // Why is this a method of the store? Should be just a method in NewActivity.vue
  async createNewActivity ({ commit }, payload) {
    // We need to return the id from the newly created activity in order
    // to be able to update (geolocation) data to that very object
    const id = await GeoMoverDB.addOne('activities', payload)
    if (parseInt(id) > -1) {
      payload.id = id
      commit('CREATE_NEW_ACTIVITY', payload)
    }
    else {
      // console.log('An error happened saving the new activity to the DB')
    }
  },
  finishNewActivity ({ commit }, payload) {
    // console.log('finish new activity id =', payload.id)
    commit('FINISH_NEW_ACTIVITY', 'finished')
    // GeoMoverDB.updateOne('activities', payload, payload.id)
  },
  pauseNewActivity ({ commit }) {
    commit('PAUSE_NEW_ACTIVITY', 'paused')
  },
  resumeNewActivity ({ commit }) {
    commit('RESUME_NEW_ACTIVITY', 'resumed')
  },
  setRecording ({ commit }, payload) {
    commit('SET_RECORDING', payload)
  },
  // @param payload array
  saveTmpCoords ({ commit }, payload) {
    // console.log('VUEX::saveTmpCoords: payload =', payload)
    commit('SAVE_TMP_COORDS', payload)
  },
  clearTmpCoords ({ commit }) {
    commit('CLEAR_TMP_COORDS')
  },
  setTotalDistance ({ commit }, obj) {
    // console.log('newActivity/actions:setTotalDistance obj =', obj)
    commit('SET_TOTAL_DISTANCE', obj)
  },
  setSpeed ({ commit }, int) {
    // console.log('newActivity/actions:setTotalDistance obj =', obj)
    commit('SET_SPEED', int)
  },
  setTotalSteps ({ commit }, obj) {
    commit('SET_TOTAL_STEPS', obj)
  }
}
